<!-- Copyright (c) 2024 VMware, Inc. All rights reserved. -- VMware Confidential -->
<div class="card">
    <div class="card-block">
        <h4>
            <cds-icon *ngIf="icon"
                      [attr.shape]="icon"
                      size="md">
            </cds-icon>
            <span>{{ label }}</span>
            <clr-signpost *ngIf="!!infoText">
                <clr-signpost-content>
                    <p [innerHTML]="infoText"></p>
                </clr-signpost-content>
            </clr-signpost>
        </h4>
        <div class="description"
             *ngIf="description"
             [innerHTML]="description">
        </div>
        <ng-content></ng-content>
    </div>
</div>
